import { render, staticRenderFns } from "./QuestionQuizFullPageV1.vue?vue&type=template&id=6efb6d55"
import script from "./QuestionQuizFullPageV1.vue?vue&type=script&lang=js"
export * from "./QuestionQuizFullPageV1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports